export default __webpack_public_path__ + "static/media/Cootie (260).354b71ab.jpg";